import styled from 'styled-components';
import {
	flexColumn, 
	// flexRow
} from '../../../style/Global';
import Card from '@material-ui/core/Card';
import Input from '@material-ui/core/Input';
import TextField from '@material-ui/core/TextField';
import {
    device
} from '../../../style/breakpoints';

export const CountriesListMenu = styled(Card)`
    border-radius:0px;
    box-shadow:none;
 
    flex:${props => props.active ? '1 1 auto' : '0 0 30%'}

`;

export const CountriesListContainer = styled.div`
    ${flexColumn}
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    width: 100%;
    height:75vh;
    @media ${device.tablet} {
        height:60vh;
        // width:90%;
    }
`;

export const CountriesListUl = styled.ul`
    display: flex;
    flex: 0 0 auto;
    flex-flow: row wrap;
    justify-content: center;
    margin: 0 5px 20px;
    min-height: 0;
    padding:0px;
    width: 100%;
`;

export const CountriesListLi = styled.li`
    align-self: flex-start;
    cursor: pointer;
    flex: 80px;
    margin: 5px;
    min-height: 71px;
    overflow: hidden;
    position: relative;
    ${flexColumn}

`;

export const TextFieldSearch = styled(TextField)`
    margin-bottom:5px;
    margin-left:10px;
    @media ${device.tablet} {
        width:90%;
    }
`

// export const CountriesListTitle = styled()

export const SearchValueInput = styled(Input)`
width:60%;
`